import { Component, computed, inject, output, signal } from '@angular/core';
import { CompaniesService } from '@app/modules/user-management/services/companies/companies.service';
import { CompanyStore } from '@app/stores/company/company.store';
import { ConfigureQrComponent } from '../configure-qr/configure-qr.component';
import { ReviewQrComponent } from '../review-qr/review-qr.component';
@Component({
    selector: 'app-qr-onboarding-stepper',
    templateUrl: './qr-onboarding-stepper.component.html',
    styleUrls: ['./qr-onboarding-stepper.component.scss'],
    imports: [ConfigureQrComponent, ReviewQrComponent],
})
export class QrOnboardingStepperComponent {
    companyService = inject(CompaniesService);
    store = inject(CompanyStore);
    clientInfo = computed(() => this.store.clientInfo());

    onCloseClientStepper = output();
    confirmCloseStepper = output();
    onClientStepChange = output();
    onClientBackChange = output();
    onQrHeaderIndexChange = output<number>();

    private state = signal({
        onBoardingStep: 1,
    });

    onboardingStep = computed(() => this.state().onBoardingStep);
    onStepChange() {
        const stepCtr = this.onboardingStep() + 1;
        this.state.update((state) => ({
            ...state,
            onBoardingStep: stepCtr,
        }));
        this.onQrHeaderIndexChange.emit(stepCtr);
    }
    onBackStep() {
        const stepCtr = this.onboardingStep() - 1;
        this.state.update((state) => ({
            ...state,
            onBoardingStep: stepCtr,
        }));
        this.onQrHeaderIndexChange.emit(stepCtr);
    }
    onClientBackClick() {
        this.onClientBackChange.emit();
    }
}
